import { doGet } from "../request";
import { ListUser } from "models/list-user";

// get your own user, if jwt token matches
export const doGetUser = async () => {
  const user = await doGet<ListUser>(`/user`);
  return user;
};
